"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAvailableVideoConferenceExtensions = getAvailableVideoConferenceExtensions;
exports.getVideoConferenceLink = getVideoConferenceLink;
exports.storeVideoHasBeenCreated = storeVideoHasBeenCreated;

var _ImmutableAPI = require("crm_data/api/ImmutableAPI");

var URI = 'extensions/video-conference/v1';

function getAvailableVideoConferenceExtensions() {
  return (0, _ImmutableAPI.get)(URI + "/applications/available");
}

function getVideoConferenceLink(payload) {
  return (0, _ImmutableAPI.post)(URI + "/link", payload);
}

function storeVideoHasBeenCreated() {
  return (0, _ImmutableAPI.post)('filemanager/api/v3/vidyard-accounts');
}